import React from 'react'
import { useConsentGiven } from 'common/hooks/useConsentGiven'
import { ConsentLevel } from 'common/data/consent/consent.redux'
import { ConsentFallback } from 'component-library/tracking/ConsentFallback/ConsentFallback'

export interface Props {
    link: string
}

if (typeof window !== 'undefined' && !(window as any).SMCX) {
    ;(window as any).SMCX = []
}

export const isSurveyMonkey = (link: string) => {
    return link.indexOf('surveymonkey.com/collect') >= 0
}

const SurveyMonkeyWithConsent: React.FC<Props> = ({ link }) => {
    const ref = React.useRef<HTMLDivElement>(null)
    React.useEffect(() => {
        if (ref.current) {
            const script = document.createElement('script')
            script.id = 'smcx-sdk'
            script.src = link
            ref.current.appendChild(script)
        }
    }, [link])

    return <div ref={ref} />
}

export const SurveyMonkeyJS: React.FC<Props> = ({ link }) => {
    const consentGiven = useConsentGiven({
        consentRequiredLevel: ConsentLevel.Analytics | ConsentLevel.Advertising,
    })

    if (!consentGiven) {
        return <ConsentFallback />
    }

    return <SurveyMonkeyWithConsent link={link} />
}
